// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroHistory_wrapper__ZIlvO","imageWrapper":"HeroHistory_imageWrapper__ygzue","textWrapper":"HeroHistory_textWrapper__OrRgk","title":"HeroHistory_title__D76Ym"};